export async function readApiError(err: unknown, fallback: string) {
  const response = (err as { response?: { json?: () => Promise<{ msg?: string }> } })
    ?.response;
  if (!response?.json) return fallback;
  try {
    const body = await response.json();
    if (body?.msg) return body.msg;
  } catch {
    return fallback;
  }
  return fallback;
}
